module.exports = __webpack_public_path__ + "fonts/Lato-Italic.7582e823.ttf";